import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from 'src/app/app.config';

@Component({
	selector: 'ma-modale-avviso',
	templateUrl: './modale-errore.component.html',
})
export class ModaleErroreComponent implements OnInit {
	constructor(
		public modal: NgbActiveModal,
		private appConfig: AppConfig,
	) {}

	message = 'Message';
	close = 'Chiudi';
	erroreHttp?: HttpErrorResponse;
	hrefInvioMail = '';

	ngOnInit() {}

	setHrefInvioMail() {
		const destinatatrioInvioEmailSegnalazioniErrore = this.appConfig.get('destinatatrioInvioEmailSegnalazioniErrore');
		const oggettoInvioEmailSegnalazioniErrore = this.appConfig.get('oggettoInvioEmailSegnalazioniErrore');
		let testoInvioEmailSegnalazioniErrore = `
<Per favore inserire una descrizione dell' errore che si sta riscontrando, se possibile allegare uno screenshot della pagina >

----------------------------

URL applicativo: ${window.location.href}
User: ${localStorage.getItem('alfresco-user')}
Timestamp: ${new Date().toISOString()}
`;
		if (this.erroreHttp) {
			testoInvioEmailSegnalazioniErrore += `
----------------------------

Url: ${this.erroreHttp.url}
Codice Errore: ${this.erroreHttp.status} - ${this.erroreHttp.statusText}
Errore: ${JSON.stringify(this.erroreHttp.error)}
`;
		}

		this.hrefInvioMail = `mailto:${destinatatrioInvioEmailSegnalazioniErrore}?subject=${encodeURIComponent(
			oggettoInvioEmailSegnalazioniErrore,
		)}&body=${encodeURIComponent(testoInvioEmailSegnalazioniErrore)}`;
	}
}

/**
 *
 * @param modalService
 * @param message
 * @param erroreHttp
 * @returns
 */
export function modaleErrore(modalService: NgbModal, message: string, erroreHttp?: HttpErrorResponse): Promise<boolean> {
	const modal = modalService.open(ModaleErroreComponent, { size: 'md' });
	modal.componentInstance.message = message;
	modal.componentInstance.erroreHttp = erroreHttp;
	modal.componentInstance.setHrefInvioMail();
	return modal.result;
}
